import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaUser } from "react-icons/fa";
import { register, reset } from "../features/auth/authSlice";
import Spinner from "../components/Spinner";
import axios from "axios";

function Register() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    password2: "",
    role: "user",
    isApproved: "true",
  });

  const { name, email, password, password2, role, isApproved } = formData;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, isLoading, isError, isSuccess, message } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (isError) {
      toast.error(message);
    }

    if (isSuccess || user) {
      //navigate("/");
    }

    //dispatch(reset());
  }, [user, isError, isSuccess, message, navigate, dispatch]);

  useEffect(()=>{
    console.log("WHAT");
  })

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (password !== password2) {
      toast.error("Passwords do not match");
    } else {
      const userData = {
        name,
        email,
        password,
        role,
        isApproved,
      };

      // dispatch(register(userData));

      const response = await axios.post("/api/users/", userData);

      if (response.data) {
        // toast user created
        toast.success("User created successfully");
      }
      else{
        toast.error("User already exists");
      }
      // reset formData
      setFormData({
        name: "",
        email: "",
        password: "",
        password2: "",
        role: "user",
        isApproved: "true",
      });

      // if (response.data) {
      //   localStorage.setItem("user", JSON.stringify(response.data));
      // }
    }
  };

  if (isLoading) {
    return <Spinner />;
  }

  if(!user || (user && user.role !== "admin")){
    return <h1>Access Denied</h1>
  }

  return (
    <>
      <section className="heading">
        <h1>
          <FaUser />
          Add New User
        </h1>
        <p>Please create an account</p>
      </section>
      <section className="form">
        <form onSubmit={onSubmit}>
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              id="name"
              name="name"
              value={name}
              placeholder="Enter employee username"
              onChange={onChange}
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              value={email}
              placeholder="Enter employee email"
              onChange={onChange}
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              className="form-control"
              id="password"
              name="password"
              value={password}
              placeholder="Enter employee password"
              onChange={onChange}
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              className="form-control"
              id="password2"
              name="password2"
              value={password2}
              placeholder="Confirm Password"
              onChange={onChange}
            />
          </div>
          <div className="form-group">
            <button type="submit" className="btn btn-block">
              Submit
            </button>
          </div>
        </form>
      </section>
    </>
  );
}

export default Register;
